import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../utils/authContext';
import { useToast } from '../../components/Auth/Toast';
import { ToastContainer } from '../../components/Auth/Toast';
import Spinner from '../../components/Auth/Spinner';
import './AuthPages.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const { forgotPassword, loading, error, setError } = useAuth();
  const { toasts, addToast, removeToast } = useToast();
  const navigate = useNavigate();

  const validateEmail = () => {
    if (!email) {
      addToast('Please enter your email', 'error');
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      addToast('Please enter a valid email', 'error');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!validateEmail()) return;

    try {
      await forgotPassword({ email });
      addToast('Reset link sent to your email!', 'success');
      setSubmitted(true);
      setEmail('');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      addToast(error || 'Failed to send reset email', 'error');
    }
  };

  return (
    <div className='auth-container'>
      <ToastContainer toasts={toasts} removeToast={removeToast} />
      
      <div className='auth-page-wrapper'>
        {/* Logo Section */}
        <div className='auth-logo-section'>
          <div className='auth-logo-container'>
            <img
              src={require('../../assets/logo/logo1.jpeg')}
              alt='Laat Sahab News Logo'
              className='auth-logo-img'
            />
            <div className='auth-logo-text'>Laat Sahab News</div>
          </div>
        </div>

        {/* Form Section */}
        <div className='auth-form-wrapper'>
          <div className='auth-header'>
            <h1>🔐 Reset Password</h1>
            <p>Enter your email to receive a reset link</p>
          </div>

          {submitted ? (
            <div className='success-message'>
              <div className='success-icon'>✅</div>
              <h2>Check Your Email</h2>
              <p>
                We've sent a password reset link to <strong>{email}</strong>
              </p>
              <p className='small-text'>
                The link will expire in 30 minutes. If you don't see the email, check your spam folder.
              </p>
              <Link to='/login' className='auth-button'>
                Back to Login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className='auth-form'>
              <div className='form-group'>
                <label htmlFor='email'>Email Address</label>
                <input
                  type='email'
                  id='email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder='Enter your email address'
                  disabled={loading}
                />
                <p className='input-hint'>
                  We'll send you a link to reset your password
                </p>
              </div>

              <button
                type='submit'
                className='auth-button'
                disabled={loading}
              >
                {loading ? <Spinner size='sm' color='white' /> : 'Send Reset Link'}
              </button>
            </form>
          )}

          <div className='auth-footer'>
            <p>
              Remember your password?{' '}
              <Link to='/login' className='auth-link'>
                Login here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
